module.exports = __webpack_public_path__ + "2c1a6b8deffd3154e071d2fa7740166b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Logos/PPN_ASSETS/WalletCard_2023_StudyInsured_en.jpg
// module id = 1514
// module chunks = 0